import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  CanActivateFn,
  Router,
  RouterStateSnapshot
} from "@angular/router";
import { inject } from "@angular/core";
import {
  AuthService
} from "./auth.service";
import { of } from "rxjs";



export const authGuardFn: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    console.warn('User is NOT authenticated. An active session is required for route ', state.url)
    const routeReturnUri: string = route.pathFromRoot
      .map(v => v.url.map(segment => segment.toString()).join('/'))
      .join('/')
    router.navigate(['/auth'], {
      queryParams: {
        returnUrl: encodeURIComponent(routeReturnUri),
        reason: 'tokenMissingOrExpired'
      }
    }).finally(()=> {})
    return of(false)
  }

  const authorizedRoles: string[] = route.data['authorizedRoles'] || []
  if (!authService.hasRoleInRange(authorizedRoles)){
    console.warn('User is authenticated but is NOT authorized to access route ', state.url, authorizedRoles)
    router.navigate(['/auth/not-authorized'], {
      queryParams: {
        targetUrl: encodeURIComponent(state.url),
        roles: encodeURIComponent(authorizedRoles.join(','))
      }
    }).finally(()=> {})
    return of(false)
  }

  const requiredClaims: {
    type: string,
    value?: any
  }[] = route.data['requiredClaims'] || []
  for(let idx = 0; idx < requiredClaims.length; idx++) {
    const c = requiredClaims[idx]
    if (!authService.hasClaim(c.type, c.value)){
      console.warn('User is authenticated but is NOT authorized to access route ', state.url, requiredClaims)
      router.navigate(['/auth/not-authorized'], {
        queryParams: {
          targetUrl: encodeURIComponent(state.url),
          claim: encodeURIComponent(c.type)
        }
      }).finally(()=> {})
      return of(false)
    }
  }

  return of(true)
};

export const authGuardChildFn: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
  authGuardFn(route, state);
